import { theme } from '@branchjs/neo-components';
import { css } from '@emotion/css';

export const getDraggableMultiValueStyles = (disabled: boolean) => {
  return {
    label: css`
      .Select-multi-value {
        ${disabled ? `background-color: ${theme.colors.gray.neutral}` : ''};
      }

      .Select__multi-value__label {
        ${disabled ? `color: ${theme.colors.gray[600]}` : ''};
      }
    `,
    icon: css`
      display: block;
    `,
    title: css`
      display: flex;
      gap: ${theme.spacing(1)};
    `,
  };
};
